import * as React from 'react'
import { FC, useMemo } from 'react'
import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'
import { get } from '@user/store/services/crud'
import { ServiceConfig } from '@user/store/services/config'
import { IOption, IProviderProps } from '@user/components/Filters'
import { selectAllLocationTypes } from '@user/store/locationTypes/slice'
import { useGetLocationTypesCached } from '@user/store/locationTypes/hooks/useGetLocationTypesOnMount'

export const LocationTypeProvider: FC<IProviderProps> = ({ render }) => {
  // fetch full list
  const { isFetching: allFetching } = useGetLocationTypesCached()
  const allLocationTypes = useSelector(selectAllLocationTypes)

  // fetch distinct list
  const { data: distinctLocationTypeIds, isFetching: distinctFetching } =
    useQuery(['filters', 'lead', 'locationType'], async () => {
      const response = await get(
        `${ServiceConfig.baseAPIUrl}${ServiceConfig.filters(
          'leads',
          'LocationTypeId',
        )}`,
      )

      const ids: string[] = await response.json()
      // remove falsey (null) values
      return ids.filter(Boolean)
    })

  const isFetching = allFetching || distinctFetching

  const distinctLocationTypes: IOption[] = useMemo(() => {
    if (!!distinctLocationTypeIds) {
      const options: IOption[] = allLocationTypes
        .filter((lt) => distinctLocationTypeIds.includes(lt.id))
        .map((lt) => ({
          label: `${lt.name} ${lt.description}`.trim(),
          value: lt.id,
        }))
      return options
    }
    return []
  }, [allLocationTypes, distinctLocationTypeIds])

  return <>{render(distinctLocationTypes, isFetching)}</>
}
LocationTypeProvider.displayName = 'LocationTypeProvider'
